import pubsub  from "@viewlift/pubsub"
import {initializeApp} from "firebase/app";
import { getAuth,GoogleAuthProvider,signInWithPopup } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import "firebase/auth";
import Cookies from 'js-cookie'
import { getDeviceId, handleStatusGaCalls } from "../../../helpers";
import trackEvent, { ANALYTICSEVENTS } from "./analyticsMap";
import { callRequest } from "../../../Graphql/request";
import { setToken } from "./constant";
import { updateAuthorisationStore } from "./authStore";
import { pushStepToFlow, triggerUserMergeEvent } from "../../helper";
import { ANALYTICS } from "../../../helpers/analyticsMap";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
let trackingID = ""
if (typeof window !== 'undefined') { 
  trackingID = window?.app_data?.appcmsPlatform?.analytics?.googleAnalyticsId
}
const firebaseDataConfig = window?.app_data?.appcmsMain?.analytics?.firebaseConfig
const firebaseConfig = {
  apiKey: firebaseDataConfig.apiKey,
  authDomain: firebaseDataConfig.authDomain,
  projectId: firebaseDataConfig.projectId,
  storageBucket: firebaseDataConfig.storageBucket,
  messagingSenderId: firebaseDataConfig.messagingSenderId,
  appId: firebaseDataConfig.appId,
  measurementId: trackingID
};

// Initialize Firebase
const app = firebaseDataConfig && firebaseDataConfig.apiKey && firebaseDataConfig.apiKey !== "" ? initializeApp(firebaseConfig) : null;
const analytics = app ? getAnalytics(app) : null;
let googleProvider, auth = null
if(app) {
  auth = getAuth();
  googleProvider = new GoogleAuthProvider()
}
export const signInWithGoogle = () => {
  if(app) {
    return signInWithPopup(auth,googleProvider)
  } else {
    return false
  }
}

const errorHandling = () => {
  pubsub.publish("isLoading", false)
  pubsub.publish('user-analytics', { ename: ANALYTICS.LOGIN_FAILURE, data: { provider: 'GOOGLE' } });
  console.log(err, 'error from google Login')
  trackEvent(ANALYTICS.LOGIN_FAILURE, { provider: "GOOGLE", error: 'Error from google Login' }, null)
}
export var googleLogin = (user,generateId, actionType) => {
  pubsub.publish('apploading',true)
    let utmCookie = Cookies.get('utm')
    let utmData = utmCookie && JSON.parse(utmCookie)
    var deviceId = getDeviceId();
      let cb = () => console.log("cb")
      let variables = {
        "site": window?.app_data?.site?.siteInternalName,
        "device": "web_browser",
        "action": actionType ? "SIGNUP" : "SIGNIN",
        "input": {
          "googleToken": user,
          "deviceId": deviceId,
          "platform" : "web_browser",
          "campaign": (utmData && utmData.utm_campaign) || "",
          "campaignSource": (utmData && utmData.utm_source) || "",
          "campaignMedium": (utmData && utmData.utm_medium) || "",
          "emailConsent" : true
        }
    }
      trackEvent('login_init', {...{method: "GOOGLE"}, ...variables},null)
      return callRequest({type : "googleValidate", variables,cb,errorHandling}).then( async (response) => {
        let res = response?.identitySigninGoogle
        const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
        let eventData = {
          "pageUrl": checkoutInitPageDetails?.pageUrl,
          "email" : res.email,
        }
        localStorage.setItem('deviceId',deviceId)
          let token = res && {
            authorizationToken: res.authorizationToken,
            refreshToken: res.refreshToken
          }
          setToken(token)
          if(res.existingUser) {
            eventData.loginVia = 'google'
            triggerUserMergeEvent(res.existingUser)
            let analyticsData={ename: ANALYTICSEVENTS.CHECKOUT_USER_LOGIN_SUCCESS, data: eventData};
            handleStatusGaCalls({eventName : 'checkout_user_login_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
            pubsub.publish('user-analytics',analyticsData)
            trackEvent('login', {method: "Google", userId: res.userId, phoneNumber: res.phoneNumber || 'NA', email: res.email || 'NA'},null)
          } else {
            eventData.registeredVia = 'google'
            triggerUserMergeEvent(res.existingUser)
            let analyticsData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_SUCCESS, data: eventData};
            handleStatusGaCalls({eventName : 'checkout_user_create_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Create Success', paymentStatus : null,eventCategory : 'Checkout'})
            pubsub.publish('user-analytics',analyticsData)
            trackEvent('sign_up', {method: "Google", userId: res.userId, phoneNumber: res.phoneNumber || 'NA', email: res.email || 'NA'},null)
          }  
          await updateAuthorisationStore({userdetails:res})
          pushStepToFlow("email added")
          if(res.isSubscribed) pubsub.publish("isAuthenticated",{...res,provider:'GOOGLE'})
            else pubsub.publish('isAuthenticated',{isSubscribed:false,provider:'GOOGLE'})
          pubsub.publish('apploading',false)
          return { type: 'LOGIN', payload: res }
      })
  }